// userSummaryAutocompleteRule: ユーザー入力に基づいて特定のJobCodeを返すためのルールセット
export const userSummaryAutocompleteRule = {
    // デフォルトのJobCode: ルールにマッチしない場合に返される値
    defaultJobCode: ['*'],

    // ルールの配列: nameはマッチング条件、JobCodeは該当するJobCodeのリスト
    rules: [
        // nameが 'DH' の場合に該当するJobCode
        { name: 'DH', JobCode: ['DH'] },

        // nameが 'RD' の場合に該当するJobCode
        { name: 'RD', JobCode: ['RD'] },

        { name: 'MD', JobCode: ['MD'] },
        { name: 'DDS', JobCode: ['DDS'] },
        { name: 'NS', JobCode: ['NS'] },
        { name: 'PT', JobCode: ['PT'] },
        { name: 'OT', JobCode: ['OT'] },
        { name: 'ST', JobCode: ['ST'] },
        { name: 'Cw', JobCode: ['CW'] },

        // nameに 'doctor' を含む場合に該当するJobCode（大文字小文字を区別しない）
        { name: '*doctor*', JobCode: ['MD'], caseIntensive: false },

        // nameが 'Dentist' で終わる場合に該当するJobCode（大文字小文字を区別しない）
        { name: '*Dentist', JobCode: ['DDS'], caseIntensive: false },

        // nameが 'OTHER' の場合は全てのJobCode
        { name: 'OTHER', JobCode: ['*'] },
    ],
};

/**
 * 関数: 入力文字列に基づいて適切なJobCodeを取得
 * @param {string} termName - 項目名
 * @returns {Array<string>} - マッチしたJobCodeの配列
 */
export function getJobCodes(termName) {
    const { defaultJobCode, rules } = userSummaryAutocompleteRule;

    for (const rule of rules) {
        const { name, JobCode, caseIntensive } = rule;

        // 大文字小文字を区別するかどうかで処理を分ける
        const inputToMatch = caseIntensive ? termName : termName.toLowerCase();
        const nameToMatch = caseIntensive ? name : name.toLowerCase();

        // ワイルドカード (*) を含む名前のマッチング処理
        const regex = new RegExp('^' + nameToMatch.replace(/\*/g, '.*') + '$');
        if (regex.test(inputToMatch)) {
            return JobCode;
        }
    }

    // どのルールにもマッチしない場合はデフォルトJobCodeを返す
    return defaultJobCode;
}